module.exports = __webpack_public_path__ + "src/assets/img/usb_02.c2a1f929.png";